export default function MediaViewer(props: { display: boolean, activeResource: any, mediaViewerVisibility: any}) {

    if (!props.display) return null;

    return (
        <div className="pdfviewer">
            <button onClick={() => props.mediaViewerVisibility(false)} className="flex algin-middle p-2">Close</button>
            <div className="iframecontainer" dangerouslySetInnerHTML={{ __html: props.activeResource }} />
        </div>
    )

}